import Vue from 'vue';
import Vuex from 'vuex';

import identity from './identity';
import messages from './messages';
import navigation from './navigation';
import authentication from './authentication';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: { identity, messages, navigation, authentication },
  state: {},
  mutations: {},
  actions: {}
});
